import { render, staticRenderFns } from "./OfferingCardWithLabels.vue?vue&type=template&id=5ae637e6&scoped=true"
import script from "./OfferingCardWithLabels.vue?vue&type=script&lang=ts"
export * from "./OfferingCardWithLabels.vue?vue&type=script&lang=ts"
import style0 from "./OfferingCardWithLabels.vue?vue&type=style&index=0&id=5ae637e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae637e6",
  null
  
)

export default component.exports